import React from "react";

const BackIcon = ({
  color = "#2B363B",
  width = 18,
  height = 18,
  opacity = 0.75,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 7 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Icono volver"
    {...props}
  >
    <path
      d="M5.83694 14.4999C5.68756 14.5004 5.53996 14.4675 5.40499 14.4034C5.27003 14.3394 5.15112 14.246 5.05701 14.13L0.227467 8.13053C0.0803987 7.95162 0 7.72719 0 7.49559C0 7.26399 0.0803987 7.03957 0.227467 6.86065L5.227 0.861218C5.39672 0.657021 5.64061 0.528609 5.90501 0.504231C6.16941 0.479854 6.43266 0.561508 6.63686 0.73123C6.84106 0.900953 6.96947 1.14484 6.99385 1.40924C7.01823 1.67364 6.93657 1.9369 6.76685 2.1411L2.29727 7.50059L6.61686 12.8601C6.73914 13.0069 6.81681 13.1856 6.84068 13.3751C6.86456 13.5646 6.83365 13.757 6.7516 13.9296C6.66955 14.1021 6.5398 14.2475 6.37771 14.3485C6.21561 14.4496 6.02795 14.5022 5.83694 14.4999Z"
      fill={color}
      fillOpacity={opacity}
    />
  </svg>
);

export default BackIcon;
